"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _SMTP = /*#__PURE__*/ _interop_require_default(require("./SMTP"));
const _ncplugin = require("~/types/nc-plugin");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let SMTPPlugin = class SMTPPlugin extends _ncplugin.XcEmailPlugin {
    getAdapter() {
        return SMTPPlugin.storageAdapter;
    }
    async init(config) {
        SMTPPlugin.storageAdapter = new _SMTP.default(config);
        await SMTPPlugin.storageAdapter.init();
    }
};
const _default = SMTPPlugin;
